import React, { useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'

const PromoDeals = () => {
  const dispatch = useDispatch()

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Promotions',
      route: null
    },
    {
      label: 'Promo Deals',
      route: null
    },
  ]

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  return (
    <AuthLayout>
      <div>Promo Deals List</div>
    </AuthLayout>
  )
}

export default PromoDeals